import type { CarrierNew } from '@eti/schema-types';
import type { BoundsType, TripSegmentType } from '../models';
import { getSegments, getTripSegments } from './trip';

export const isRyanAirLccSupplierForTrip = (bounds: BoundsType) => {
  const segments = getSegments(bounds);
  const tripSegments = getTripSegments(segments);

  return tripSegments.some(
    (segment) => segment?.lccSupplier?.replace(/ +/g, '').match(/ryanair/gi),
  );
};

const getMarketingCarriersFor = (segments: TripSegmentType[]) =>
  segments.map((segment) => segment.marketingCarrier);

const generateLink = ({ name, conditions }: CarrierNew) =>
  `<a href="${conditions?.url}" target="_blank" rel="noopener noreferrer">${name}</a>`;

const getCarrierLinks = (tripSegments: TripSegmentType[]) => {
  const marketingCarriers = getMarketingCarriersFor(tripSegments);

  const links = Array.isArray(marketingCarriers)
    ? marketingCarriers.reduce<string[]>(
        (acc, carrier) =>
          carrier.name && carrier.conditions?.url ? [...acc, generateLink(carrier)] : acc,
        [],
      )
    : [];

  return Array.from(new Set(links));
};

export const getCarrierConditionsLinks = (bounds: BoundsType) => {
  const segments = getSegments(bounds);
  const tripSegments = getTripSegments(segments);
  const carrierLinks = getCarrierLinks(tripSegments);

  return carrierLinks.length ? carrierLinks.join(', ') : '';
};

export const getMarketingCarrierCodesList = (bounds: BoundsType) => {
  const segments = getSegments(bounds);
  const tripSegments = getTripSegments(segments);
  const marketingCarriers = getMarketingCarriersFor(tripSegments);

  return Array.from(
    new Set(
      Array.isArray(marketingCarriers) ? marketingCarriers.map((carrier) => carrier.code) : [],
    ),
  );
};
